import React from 'react';
import { getAssetPath } from '../utils/paths';
import CalendlyButton from './CalendlyButton';
import './Contact.css';

const Contact = () => {
  const contactInfo = [
    {
      icon: '✉️',
      title: "Email",
      value: "mary.carpenter@pronurselegal.net",
      link: "mailto:mary.carpenter@pronurselegal.net"
    },
    {
      icon: '📞',
      title: "Phone",
      value: "727-418-3696",
      link: "tel:7274183696"
    },
    // LinkedIn hidden for now - will be updated later
    // {
    //   icon: null,
    //   image: null,
    //   title: "LinkedIn",
    //   value: "LinkedIn profile",
    //   link: null
    // },
    {
      icon: '📍',
      title: "Location",
      value: "Multi-state Nursing License",
      link: null
    }
  ];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Contact</h2>
          <p className="section-subtitle">
            Expert care from the bedside to the courtroom
          </p>
        </div>

        <div className="contact-content">
          {/* Profile Image Section */}
          <div className="contact-profile-image-section">
            <img 
              src={getAssetPath('profile.jpg')}
              alt="Profile" 
              className="contact-profile-image"
              onError={(e) => {
                console.error('Image failed to load:', e.target.src);
                // Try absolute path as fallback
                e.target.src = '/pronurselegal/profile.jpg';
              }}
            />
          </div>

          <div className="contact-info-card">
            <h3>Let's Connect</h3>
            <p>
              Content to be filled in later.
            </p>
            <p>
              Content to be filled in later.
            </p>
          </div>

          <div className="contact-details">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className="contact-item"
              >
                <div className="contact-icon">
                  {info.image ? (
                    <img src={info.image} alt={info.title} className="contact-image" />
                  ) : (
                    info.icon
                  )}
                </div>
                <div className="contact-text">
                  <h4>{info.title}</h4>
                  {info.link ? (
                    <a href={info.link} target="_blank" rel="noopener noreferrer">
                      {info.value}
                    </a>
                  ) : (
                    <span>{info.value}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
          
          <div className="calendly-button-section">
            <CalendlyButton />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

